import styled from 'styled-components';
import { colors, fontWeights, fonts } from '../../../theme/styled';
import { SocialIcons } from '../../../components/socialIcons/socialIcons.component';
import { TextBlock } from '../../../components/textBlock/textBlock.component';
import { title, text } from '../../../theme/typography';
import { Wrapper, Container } from '../../../theme/layout';
import { Link } from '../../../components/link/link.component';
import { media, sizes } from '../../../theme/media';
import { Image as ResponsiveImage } from '../../../components/image';
import { backgroundUrl } from '../../../utils/rendering';
import { LinkList as LinkListComponent } from '../../../components/linkList/linkList.component';

export const ContentWrapper = styled.section`
  background-color: ${props => props.color || colors.darkGrey};
  box-sizing: border-box;
  position: relative;
  padding-bottom: 30px;

  ${media.tablet`
    padding-bottom: 0;
  `};

  ${media.tabletLarge`
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 80px;
  `};

  input[type='text'],
  input[type='email'],
  input[type='search'] {
    height: 44px;
    text-align: left;
  }
`;

export const FooterSocialIcons = styled(SocialIcons)`
  color: ${colors.white};
  align-items: center;
  width: auto;
  padding-top: 28px;

  img {
    width: 28px;
  }

  h2 {
    font-size: 18px;
    text-transform: uppercase;
  }

  li {
    margin-left: 16px;

    &:first-child {
      margin-left: 0;
    }
  }

  ${media.tabletLarge`
    padding-top: 0;

    img {
      width: 100%;
    }

    li {
      margin-left: 12px;
    }
  `}
`;

export const FooterShop = styled(TextBlock)`
  margin-top: 20px;

  ${media.tablet`
    margin-top: 20px;
  `};

  ${media.desktop`
    margin-top: 20px;
  `};

  p {
    ${title};
    font-size: 18px;
    line-height: 1.33;
    margin-top: 0;
    letter-spacing: 1px;
    color: ${colors.white};
    margin-bottom: 20px;
    max-width: 197px;

    ${media.tablet`
      max-width: 100%;
    `}
  }

  a {
    min-width: auto;
    width: 160px;
    height: 48px;
    line-height: 48px;

    ${media.tabletLarge`
      font-size: 14px;
    `}
  }
`;

export const FooterImage = styled.div`
  position: absolute;
  top: 67px;
  left: 0;
  width: 268px;
  height: 479px;
  z-index: 0;
  background-image: ${backgroundUrl('src')};
  background-size: contain;
  background-position: right bottom;
  background-repeat: no-repeat;

  ${media.tablet`
    left: auto;
    right: 0;
    transform: scaleX(-1);
  `};

  ${media.tabletLarge`
    width: 300px;
    height: auto;
    top: 0;
    bottom: 0;
    right: auto;
    left: 0;
    transform: scaleX(1);
  `};
`;

export const RowWrapper = styled(Wrapper)`
  z-index: 1;
  position: relative;
`;

export const Row = styled(Container)`
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: wrap;
  `};
`;

export const ShopItem = styled(Link)`
  position: relative;
  right: -13px;

  ${media.tablet`
    margin-bottom: 52px;
  `};

  ${media.tabletLarge`
    margin-bottom: 40px;
  `};

  ${media.desktop`
    left: 25px;
  `};
`;

export const SHOP_IMAGE_SIZES = {
  [sizes.mobile]: 120,
  [sizes.tablet]: 80,
  [sizes.tabletLarge]: 80,
  [sizes.desktop]: 120,
};

export const ShopImage = styled(ResponsiveImage)`
  width: 120px;

  ${media.mobile`
    width: 120px;
  `};

  ${media.tablet`
    width: 80px;
  `};

  ${media.tabletLarge`
    width: 80px;
  `};

  ${media.desktop`
    width: 120px;
  `};
`;

export const LinkList = styled(LinkListComponent)`
  padding-left: 0;
  padding-right: 0;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 28px;

  nav {
    width: 100%;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  h2 {
    ${title};
    font-size: 16px;
    color: ${colors.white};
    margin-bottom: 8px;
    line-height: 1.25;
    letter-spacing: 0.9px;
  }

  li {
    display: block;
  }

  a {
    ${text};
    font-family: ${fonts.smallFont};
    font-weight: ${fontWeights.normal};
    color: ${colors.white};
    font-size: 14px;
    display: block;
    line-height: 1.79;

    &:focus,
    &:hover {
      outline: none;
      text-decoration: underline;
    }
  }
`;

export const Column1 = styled(Container)`
  padding-left: 0;
  padding-right: 0;
  margin-top: 60px;
  align-items: flex-start;

  ${media.tablet`
    width: 60%;
    margin-top: 0;
    padding: 40px;
    order: 1;
  `};

  ${media.tabletLarge`
    width: 40%;
    order: 1;
    padding-bottom: 0;
    padding-left: 0;
  `};

  ${media.desktopSmall`
    width: 35%;
  `};

  ${media.desktop`
    width: 32.5%;
  `};
`;

export const Column2 = styled(Container)`
  ${media.tablet`
      width: 100%;
      order: 3;
      flex-shrink: 0;
      align-items: flex-start;
  `};

  ${media.tabletLarge`
      width: 16%;
      order: 2;
      padding-top: 68px;
      padding-right: .5rem;
  `};

  ${media.desktop`
      width: 17.5%;
  `};
`;

export const Column3 = styled(Container)`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  ${media.tablet`
    width: 100%;
    order: 4;
    align-items: flex-start;
  `};

  ${media.tabletLarge`
    width: 14%;
    order: 3;
    padding-top: 68px;
    border-bottom: none;
    padding-left: .5rem;
  `};

  ${media.desktop`
    width: 17.5%;
  `};
`;

export const Column4 = styled(Container)`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 0;

  ${media.tablet`
    padding-left: 0;
    padding-right: 40px;
    width: 40%;
    padding-top: 48px;
    order: 2;
  `};

  ${media.tabletLarge`
    width: 30%;
    order: 4;
    padding-right: 0;
    padding-left: 40px;
    display: flex;
    flex-direction: column;
  `};

  ${media.desktopSmall`
    width: 30%;
  `};

  ${media.desktop`
    width: 32.5%;
  `};
`;

export const FooterBadges = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  ${media.tabletLarge`
    order: 1;
    margin: 0 0 40px;
  `}

  > * {
    margin: 0 20px 0 0;
  }
`;

export const FooterShopWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;

  ${media.tablet`
    margin: 0 0 40px;
  `}

  ${media.tabletLarge`
    justify-content: flex-start;
    order: 0;
  `}
`;

export const SubscribeFormWrapper = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;

  ${media.tablet`
    background: ${colors.black};
    padding: 18px 32px 0;
    clip-path: polygon(100% 0, 100% calc(100% - 2.5rem), calc(100% - 2.5rem) 100%, 0 100%, 0 0);
  `}
`;
